/**
 * A copy do ERRO DO TURNO — a MESMA régua para as DUAS superfícies que
 * mostram/falam o desfecho de um turno que falhou.
 *
 * ★ [G-4 do design it.2] Extraído de `chat-message.vue` (spec-019
 * T004-delta, 09/09) — a régua nasceu ali, sozinha, e o Modo de Voz
 * (`apiChat.js::_falarDesfechoDeErro`) chamava `data.message` CRU: a bolha
 * mostrava a copy limpa e a voz lia o traceback em voz alta (nome de classe
 * de exceção, caminho de arquivo) — pior que o silêncio que a spec-019 veio
 * consertar, e exatamente o "sem código cru" que o AC2 da US-4 pede. Duas
 * listas de marcas divergiriam com o tempo; UMA fonte de verdade (Coding
 * standards do CLAUDE.md raiz) é o que impede as duas telas de contarem
 * histórias diferentes do MESMO erro.
 *
 * O envelope de erro do servidor é montado com `str(e)` do `except
 * Exception`, e as duas superfícies confiavam nele: só caíam na copy da
 * casa quando a mensagem vinha VAZIA. A régua abaixo é deliberadamente
 * ESTREITA — reconhece o que é inequivocamente técnico (traceback, nome de
 * classe de exceção, caminho de arquivo, dict cru) e deixa passar o resto.
 * Distinguir "falha de rede" de "exceção de programação" é trabalho do
 * BACKEND, que sabe qual foi; este filtro é a rede de segurança do lado de
 * cá, não o conserto — a própria régua é heurística: acerta o traceback
 * óbvio e erra a mensagem de meio-termo (mesma nota de
 * `test_erro_do_turno_sem_excecao_crua.py` no backend).
 */

// Mensagem de erro sempre inclui solução (§UX do CLAUDE.md): não só que
// falhou, mas o que fazer.
const COPY_ERRO_SEM_MENSAGEM =
  'Não foi possível concluir esta resposta. Tente novamente em instantes.'

const MARCAS_DE_EXCECAO = [
  /traceback/i,
  /\b[A-Z][A-Za-z0-9_]*(Error|Exception)\b/,
  /File "[^"]+"/,
  /\.py\b/,
  /\bat 0x[0-9a-f]+/i,
  /^\{[\s\S]*\}$/,
]

/** `true` quando a frase é log, não conversa. */
function pareceExcecaoCrua(texto) {
  return MARCAS_DE_EXCECAO.some(function (marca) {
    return marca.test(texto)
  })
}

/**
 * A explicação do servidor, ou a nossa quando ele não deu nenhuma — nem uma
 * que seja log em vez de frase. Usada tanto pela BOLHA (`chat-message.vue`,
 * texto) quanto pela FALA (`apiChat.js`, Modo de Voz): a mesma função, os
 * mesmos dois desfechos possíveis, nunca duas listas.
 *
 * @param {?string} mensagem `erro_do_turno.message` (ou `data.message` do
 *   evento SSE `error`) — pode vir `null`/`undefined`/vazia.
 * @returns {string} nunca vazia.
 */
function copyDoErroDoTurno(mensagem) {
  const doServidor = String(mensagem === null || mensagem === undefined ? '' : mensagem).trim()
  if (!doServidor) return COPY_ERRO_SEM_MENSAGEM
  return pareceExcecaoCrua(doServidor) ? COPY_ERRO_SEM_MENSAGEM : doServidor
}

export { COPY_ERRO_SEM_MENSAGEM, MARCAS_DE_EXCECAO, pareceExcecaoCrua, copyDoErroDoTurno }
